import VueConfirmCode from './vue-confirm-code.vue'
import { events } from './events'

export default {
  install(Vue, args = {}) {
    if (this.installed) return

    this.installed = true
    this.params = args

    Vue.component(args.componentName || 'vue-confirm-code', VueConfirmCode)

    const confirmCode = params => {
      if (typeof params !== 'object' || Array.isArray(params)) {
        let caughtType = typeof params
        if (Array.isArray(params)) caughtType = 'array'

        throw new Error(
          `Options type must be an object. Caught: ${caughtType}. Expected: object`,
        )
      }

      if (typeof params === 'object') {
        if (
        // eslint-disable-next-line no-prototype-builtins
          params.hasOwnProperty('callback')
          && typeof params.callback !== 'function'
        ) {
          const callbackType = typeof params.callback
          throw new Error(
            `Callback type must be an function. Caught: ${callbackType}. Expected: function`,
          )
        }
        events.$emit('open', params)
      }
    }
    confirmCode.close = () => {
      events.$emit('close')
    }

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$confirmCode = confirmCode
    // eslint-disable-next-line no-param-reassign
    Vue.$confirmCode = confirmCode
  },
}
